import { RootState } from '~/store';

export const selectGeneralSettingsProfileId = (state: RootState): string => {
  return state?.generalSettings?.profileId;
};

export const selectRemindersAreEnabled = (state: RootState): boolean => {
  return state?.generalSettings?.remindersAreEnabled;
};
